import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg18Coupon2 = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillOpacity: 0.86,
      fillRule: "evenodd",
      d: "M15.06 4.1a.9.9 0 0 1 .9.906l-.06 8.92a.9.9 0 0 1-.9.894H3a.9.9 0 0 1-.9-.92l.06-2.63a.9.9 0 0 1 .9-.88l.11-.006A.935.935 0 0 0 4 9.45a.935.935 0 0 0-.94-.94l-.113-.007a.9.9 0 0 1-.787-.893V5a.9.9 0 0 1 .9-.9zm-.906 1.8H3.96v.961l.058.02a2.74 2.74 0 0 1 1.777 2.402l.005.167c0 1.18-.74 2.182-1.782 2.569l-.076.025-.022.976h10.186zM11.1 10.81a.6.6 0 0 1 .592.503l.008.097v.31a.6.6 0 0 1-1.192.097l-.008-.097v-.31a.6.6 0 0 1 .6-.6m0-2.1a.6.6 0 0 1 .592.503l.008.097v.3a.6.6 0 0 1-1.192.097L10.5 9.61v-.3a.6.6 0 0 1 .6-.6m0-2.1a.6.6 0 0 1 .592.503l.008.097v.3a.6.6 0 0 1-1.192.097L10.5 7.51v-.3a.6.6 0 0 1 .6-.6"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18Coupon2$1 = Svg18Coupon2;

export { Svg18Coupon2$1 as default };
